import style from './FilterContainer.module.css';

import Select, { components } from 'react-select';

const FILTER_FIELD_FONT_SIZE = "14px";
const FILTER_BORDER_COLOR = "rgba(0, 0, 0, 0.2)";
const FILTER_BORDER_COLOR_HOVER = "rgba(0, 0, 0, 0.35)";
const FILTER_BORDER_COLOR_FOCUS = "#007bff";
const FILTER_BORDER_RADIUS = "8px";
const FILTER_FOCUS_SHADOW = "0 0 0 2px rgba(0, 123, 255, 0.15)";

/** Acima do thead sticky do SortableTable (z-index: 2) e de overlays comuns (z-index: 99999) */
const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "38px",
        fontSize: FILTER_FIELD_FONT_SIZE,
        borderRadius: FILTER_BORDER_RADIUS,
        borderWidth: "1px",
        borderColor: state.isFocused ? FILTER_BORDER_COLOR_FOCUS : FILTER_BORDER_COLOR,
        boxShadow: state.isFocused ? FILTER_FOCUS_SHADOW : "none",
        backgroundColor: "#fff",
        "&:hover": {
            borderColor: state.isFocused ? FILTER_BORDER_COLOR_FOCUS : FILTER_BORDER_COLOR_HOVER,
        },
    }),
    valueContainer: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE }),
    placeholder: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE, color: "#666" }),
    input: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE }),
    singleValue: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE }),
    multiValue: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE }),
    multiValueLabel: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE }),
    option: (base) => ({ ...base, fontSize: FILTER_FIELD_FONT_SIZE }),
    menu: (base) => ({ ...base, zIndex: 100000 }),
    menuPortal: (base) => ({ ...base, zIndex: 100000 }),
};

const FilterContainer = ({ type, placeholder, options, optType, changeFunc, valor, maxLength }) => {

    const valores = optType === 'obj'
        ? options.map(opt => ({ value: opt, label: opt }))
        : options

    const ValueContainer = ({ children, ...props }) => {

        let [values, input] = children
        if (Array.isArray(values)) {

            const plural = values.length === 1 ? "" : "S";
            values = `${values.length} SELECIONADO${plural}`

        }

        return (

            <components.ValueContainer {...props} >
                {values}
                {input}
            </components.ValueContainer>

        )

    }

    return (
        <div className={style.container} >
            {
                type === 'select' ? (

                    <Select
                        placeholder={placeholder}
                        options={valores}
                        isClearable
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ ValueContainer }}
                        onChange={(selected) => changeFunc(selected)}
                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                        styles={selectStyles}
                        {...(valor !== undefined ? { value: valor ?? [] } : {})}
                    />

                ) : (

                    <input
                        type={type}
                        placeholder={placeholder}
                        onChange={(e) => {

                            let valorInput = e.target.value

                            if( type === 'text' ){

                                valorInput = valorInput.toUpperCase();

                            }

                            changeFunc( valorInput )
                        }}
                        value={valor}
                        maxLength={maxLength}
                    />

                )
            }
        </div>
    )

}

export default FilterContainer;